module.exports = __webpack_public_path__ + "img/icon.451d76c7.jpg";